// extracted by mini-css-extract-plugin
module.exports = {"cardBox":"oam-status-card_cardBox__14CGw","statusBox":"oam-status-card_statusBox__2mGyC","statusInfo":"oam-status-card_statusInfo__yizEw"};